export default __webpack_public_path__ + "static/media/user_placeholder.0539bd70.png";